__turbopack_context__.v({
  "Loader": "Loader-module-scss-module__4qIAAa__Loader",
});
